/* eslint-disable object-shorthand,prefer-const,no-unused-vars,no-console */
'use strict';

import _, {get, find} from 'lodash';
import moment from 'moment';
import cx from 'classnames';
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import ReactTooltip from 'react-tooltip';

import {lookup, getLookupValue} from '../../../../../../redux/helpers/staticData';
import * as contactApi from '../../../../../../redux/actionCreators/async/contacts';
import * as contactStore from '../../../../../../redux/actionCreators/sync/contacts';
import * as companyApi from '../../../../../../redux/actionCreators/async/companies';

import IconButton from 'material-ui/IconButton';
import CheckList from '../../../../../../common/components/c_CheckList';
import StatusDropDown from '../../../../../../common/components/StatusDropDown';
import EmailIcon from '../../../../../../common/svgs/EmailIcon';
import EditIcon from '../../../../../../common/svgs/EditIcon';
import FlagIcon from '../../../../../../common/svgs/FlagIcon';
import TransferItemOwnershipDialogIcon from '../../../../../../common/svgs/TransferItemOwnershipDialogIcon';
import EditContactDetails from '../EditDetails';
import EmailDialog from '../.././../../Emails';
import JobRequestTransferOwnership from '../../JobRequestTransferOwnership';
import prettyPhone from '../../../../../../lib/prettyPhone';
import {getPins} from '../../../../../../redux/actionCreators/async/employees';
import * as syncActionCreators from '../../../../../../redux/actionCreators/sync';

const MODES = {
  empty : 0,
  view  : 1,
  edit  : 2
};

@connect((store) => {
  // users "entire" roles, not just names
  const userRoles = store.staticData.employeeRoles.filter(role => store.user.roles.includes(role.name));
  // roles allowed to transfer
  const requiredRoles = store.staticData.employeeRoles.filter(role => role.hardcodelink === 'SYSTEM_ADMINISTRATOR' || role.hardcodelink === 'EMPLOYEE');
  // ensure that user has all the required roles to transfer
  const transferButtonAllowed = requiredRoles.every(role => userRoles.includes(role));
  return {
    staticData  : store.staticData,
    currentUser : store.user,
    contact     : get(store.admin, 'contactInContactWorksheet', {}),
    showTransferOwnershipButton: transferButtonAllowed
  };
})
export default class ContactDetails extends React.Component {
  static propTypes = {
    dispatch    : PropTypes.func.isRequired,
    contact     : PropTypes.object.isRequired,
    staticData  : PropTypes.object.isRequired,
    currentUser : PropTypes.object,
    showTransferOwnershipButton: PropTypes.bool
  };

  constructor(props, context) {
    super(props, context);

    const mode = (props.contact) ? MODES.view : MODES.empty;
    const initialState = {
      mode,
      clientAdvisors      : this.props.staticData.clientAdvisers,
      relationshipManagers: this.props.staticData.relationshipManagers,
      showEmail           : false,
      tags                : get(this.props.contact, 'profile.tags', []),
      showJobRequestTransferOwnershipModal: false
    };

    this.state = initialState;
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  switchModes(mode = MODES.view) {
    this.setState({...this.state, mode });
    ReactTooltip.rebuild();
  }

  toggleJobRequestTransferOwnershipModal = () => {
      this.setState({...this.state, showJobRequestTransferOwnershipModal: !this.state.showJobRequestTransferOwnershipModal });
      ReactTooltip.rebuild();
  };

  toggleEmailModal = () => {
    this.setState({...this.state, showEmail: !this.state.showEmail });
    ReactTooltip.rebuild();
  };

  handleJobRequestTransferOwnership = () => this.toggleJobRequestTransferOwnershipModal();

  handleEmail = () => this.toggleEmailModal();

  handleEdit = () => this.switchModes(MODES.edit);

  handleClose = () => this.switchModes();

  handleStatusChange = (contactId, companyId) => (event, value) => {
    if (value) {
      this.props.dispatch(companyApi.updateCompanyStatus(companyId, value, (err, result) => {
        if (err || !result) {
          return console.error(err || 'Update failed.');
        }

        // refresh contact
        this.props.dispatch(contactApi.getContact(contactId, (err, data) => {
          if (err || !data) {
            return console.error(err || 'Fetch failed.');
          }
          this.props.dispatch(contactStore.updateContactInContactWorksheet(data));
        }));
      }));
    }
  };

  handleTagChange = (contactId) => (event, value) => {
    let doAdd = true;
    let tagId = -1;
    const currentTags = this.props.contact.profile.tags || [];
    const addedTags = _.difference(value, currentTags);

    if (addedTags.length) {
      tagId = addedTags[0];
    }
    else {
      const removedTags = _.difference(currentTags, value);
      tagId = removedTags[0];
      doAdd = false;
    }

    const tagRequest = {contactId: contactId, tagId: tagId};
    const tagCallback = (err, result) => {
      if (err) {
        return console.error(err || 'Update failed.');
      }

      let updatedContact = this.props.contact;
      let updatedTags = updatedContact.profile.tags || [];
      if (doAdd) {
        updatedTags.push(tagId);
      }
      else {
        _.pull(updatedTags, tagId);
      }
      updatedContact.profile.tags = updatedTags;
      const contactData = {contact: updatedContact, group: updatedContact.profile.contactStatusGroup};
      this.props.dispatch(contactStore.updateContactInContactWorksheet(contactData));
      this.setState({tags: updatedTags});
    };

    const tagAction = doAdd ? contactApi.addTag(contactId, tagRequest, tagCallback) : contactApi.deleteTag(contactId, tagRequest, tagCallback);
    this.props.dispatch(tagAction);
  };

  renderView(showEmail, showJobRequestTransferOwnershipModal) {
    const {
      user = {},
      profile = {},
      company = {}
    } = this.props.contact || {};
    const staticData = this.props.staticData;

    const currentStatus = getLookupValue(staticData, 'companyStatus', {id: get(company, 'companyStatus')});
    const sanitize = (val) => val || '';
    const expand = (type, val) => sanitize(lookup(staticData, type, val));
    const formattedAddress = () => `${sanitize(user.address)}${(user.address2 ? ` ${user.address2}` : '')}
                                    ${sanitize(user.city)}, ${expand('stateList', {id: user.state})}, ${sanitize(user.zip)}`;
    const lastUpdated = [user.dateModified, profile.dateModified, user.dateCreated, profile.dateCreated]
                        .filter(d => !!d)
                        .sort((d1, d2) => moment.utc(d2).diff(moment.utc(d1)))
                        .shift();
    const adviser = this.state.clientAdvisors.find((item) => item.employeeId === profile.clientAdvisorId);
    const relationshipMgr = this.state.relationshipManagers.find(item => item.employeeId === company.relationshipManagerId);

    const followUpTask = _(get(profile, 'tasks', []))
                            .filter(task => task.taskFollowUpDate && !task.closed)
                            .sortBy(task => new Date(task.taskFollowUpDate))
                            .head();

    const mainPhone = find(staticData.contactPhoneTypes, {name: 'Main'});
    const mainPhoneId = get(mainPhone, 'id');

    return (
      <div className='view-contact-card'>
        <div className='contact-col1'>
          <h1>{`${user.firstName} ${user.lastName}`}</h1>
          <div>Client Adviser: {adviser ? `${adviser.firstName} ${adviser.lastName}` : ''}</div>
          <div>Relationship Manager: {relationshipMgr ? `${relationshipMgr.firstName} ${relationshipMgr.lastName}` : ''}</div>
          <div>Company: <span className='hover-link' onClick={(e) => this.props.dispatch(push(`/admin/companies/${company.id}/details`))}>{sanitize(company.name)}</span></div>
          <div>{user.email}</div>
          <div>{formattedAddress()}</div>
        </div>
        <div className='contact-col2'>
          <div>{expand('timezoneList', {id: user.timezone})}</div>
          <div>Contact Date: {profile.dateCreated ? moment(profile.dateCreated).format('L') : sanitize(profile.dateCreated)}</div>
          <div>Last Updated: {moment(lastUpdated).format('L')}</div>
          <div>Follow Up: {followUpTask ? moment(followUpTask.taskFollowUpDate).format('L') : sanitize(followUpTask)}</div>

          <div>{user.phoneNumber1 && user.phoneType1 && `${expand('contactPhoneTypes', {id: user.phoneType1})}: `}{user.phoneNumber1 && prettyPhone(user.phoneNumber1)}{user.phoneType1 === mainPhoneId && user.phoneExtension1 && ` ext ${user.phoneExtension1}`}</div>
          <div>{user.phoneNumber2 && user.phoneType2 && `${expand('contactPhoneTypes', {id: user.phoneType2})}: `}{user.phoneNumber2 && prettyPhone(user.phoneNumber2)}{user.phoneType2 === mainPhoneId && user.phoneExtension2 && ` ext ${user.phoneExtension2}`}</div>

        </div>
        <div className='contact-col3'>
          <div className='contact-status-section'>
            <StatusDropDown
              status={currentStatus}
              smallDisplay={true}
              menuItems={this.props.staticData.companyStatus}
              onChange={this.handleStatusChange(profile.id, company.id)}
              data-id='status'
            />
            <CheckList
              className={'tag-selector'}
              data-id={'Tag'}
              persistentLabel={'Tag'}
              menuItems={this.props.staticData.contactTags}
              defaultValue={profile.tags || []}
              popoverStyle={{width: '300px'}}
              popoverClassName={'tag-selector-checklist-dropdown'}
              autoWidth={true}
              onChange={this.handleTagChange(profile.id)}
            />
          </div>
          <div className='contact-tags'>
            {_.map(this.state.tags, (tag) => {
              return (<div className='contact-tag' data-id={`Contact tag ${tag}`}><FlagIcon /> {lookup(this.props.staticData, 'contactTags', {id: tag})}</div>);
            })}
          </div>
          <br />
          <ul className='buttons'>
            {
              this.props.showTransferOwnershipButton
              &&
              <li>
                <IconButton data-id='Transfer Icon' tooltip='Transfer Job Requests' tooltipPosition='bottom-center' onClick={this.handleJobRequestTransferOwnership}>
                  <TransferItemOwnershipDialogIcon onClick={this.handleJobRequestTransferOwnership} />
                </IconButton>
              </li>
            }
            <li>
              <IconButton data-id='Edit Icon' tooltip='Edit' tooltipPosition='bottom-center' onClick={this.handleEdit}>
                <EditIcon onClick={this.handleEdit} />
              </IconButton>
            </li>
            <li>
              <IconButton data-id='Email Icon' tooltip='Email' tooltipPosition='bottom-center' onClick={this.handleEmail}>
                <EmailIcon />
              </IconButton>
            </li>
            <li className='job-counts'>
              <div data-tip='Total Job Requests' className={cx('large total-circle', {'empty-circle': profile.jobs === 0})}>
                {profile.jobs > 99 ? '99+' : profile.jobs}
              </div>
            </li>
            {profile.jobsPlaced > 0
              &&
              <li className='job-counts'>
                <div data-tip='Job Requests Placed' className='large placed-circle'>
                  {profile.jobsPlaced > 99 ? '99+' : profile.jobsPlaced}
                </div>
              </li>
            }
            {profile.jobsApproved > 0
              &&
              <li className='job-counts'>
                <div data-tip='Job Requests Approved' className='large approved-circle'>
                  {profile.jobsApproved > 99 ? '99+' : profile.jobsApproved}
                </div>
              </li>
            }
            {profile.jobsSubmitted > 0
              &&
              <li className='job-counts'>
                <div data-tip='Job Requests Submitted' className='large submitted-circle'>
                  {profile.jobsSubmitted > 99 ? '99+' : profile.jobsSubmitted}
                </div>
              </li>
            }
          </ul>
        </div>
        {
          this.props.showTransferOwnershipButton
          && showJobRequestTransferOwnershipModal
          &&
          <JobRequestTransferOwnership
            contact={this.props.contact}
            dispatch={this.props.dispatch}
            onClose={this.toggleJobRequestTransferOwnershipModal}
            staticData={this.props.staticData}
          />
        }
        {
          showEmail
          &&
          <EmailDialog
            contact={this.props.contact}
            dispatch={this.props.dispatch}
            onClose={this.toggleEmailModal} />
        }
      </div>
    );
  }

  renderEdit() {
    return (
      <EditContactDetails
        contact={this.props.contact}
        clientAdvisors={this.state.clientAdvisors}
        relationshipManagers={this.state.relationshipManagers}
        timezoneList={this.props.staticData.timezoneList}
        stateList={this.props.staticData.stateList}
        contactPhoneTypes={this.props.staticData.contactPhoneTypes}
        dispatch={this.props.dispatch}
        onClose={this.handleClose}
        currentUser={this.props.currentUser}
      />
    );
  }

  render() {

    return (
      <div className='contact-worksheeet-details'>
      {
        (this.state.mode === MODES.view)
          &&
        this.renderView(this.state.showEmail, this.state.showJobRequestTransferOwnershipModal)
          ||
        (this.state.mode === MODES.edit)
          &&
        this.renderEdit()
      }

        <ReactTooltip />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/Header/Details/index.js